<template>
  <bk-page class="homePage">
    <bk-view class="view-top">

      <bk-view class="view-header">
        <bk-image :src="maseLogo"></bk-image>
        <bk-button type="icon" class="btn-search" icon="icon-search" @click="showSubPage('bkShopSearch')"></bk-button>
      </bk-view>

      <bk-view class="view-location overflowText">
        <bk-lang v-if="!locationText" code="home_text_loading"></bk-lang>
        {{locationText || ''}}
      </bk-view>

      <bk-view v-if="recShopList && recShopList.length > 0" class="view-recommended">
        <bk-view class="view-title">
          <bk-title lang-code="home_title_newList"></bk-title>
        </bk-view>
        <bk-view class="view-list horiScrollView">
          <bk-view class="view-shopItem" v-for="(item, index) in recShopList" :key="index" @click="shopItemClick(item)">

            <bk-image :src="item.showCoverImg"></bk-image>

            <bk-view class="view-text">
              <bk-view class="view-name overflowText">
                {{item.name}}
              </bk-view>
              <bk-view class="view-address overflowText">
								<bk-icon icon="icon-dizhi"></bk-icon>
        				<span>{{ item.address }}</span>
              </bk-view>
            </bk-view>

          </bk-view>
        </bk-view>
      </bk-view>

    </bk-view>

    <bk-view :style="{marginTop: recShopList?.length > 0 ? '0' : '-280px'}" class="view-nearShopList">
      <bk-view class="view-title">
        <bk-title langCode="home_title_nearBy" :style="{color: recShopList?.length > 0 ? '#333' : '#fff'}"></bk-title>
      </bk-view>
      <bk-view class="view-list">

        <van-swipe class="swipe-near" :autoplay="0" indicator-color="white">
          <van-swipe-item v-for="groupItem in nearShopList">
            <ShopItem v-for="item in groupItem.list" :item="item"></ShopItem>
          </van-swipe-item>

        </van-swipe>

      </bk-view>
    </bk-view>

    <bk-view v-if="topRatedShopList?.length > 0" class="view-topRatedShopList">
      <bk-view class="view-title">
        <bk-title langCode="home_title_topRated"></bk-title>
      </bk-view>
      <bk-view class="view-list">

        <ShopItem v-for="item in topRatedShopList" :item="item"></ShopItem>

      </bk-view>
    </bk-view>

    <transition name="rightFadeIn">
      <bkShopSearch v-if="showPage == 'bkShopSearch'" @close="showSubPage(undefined)" />
    </transition>

  </bk-page>
</template>

<script>

	import {shopReq, reportReq} from '@/reqService/index';
	import ShopItem from './subViews/shopItem/shopItem';
	import bkShopSearch from '@/components/bk-business/bk-shopSearch/bk-shopSearch';
	import BkImage from '../../components/bk-base/bk-image/bk-image';

	export default {
		name: 'home',
		components: {
			BkImage,
			ShopItem,
			bkShopSearch
		},
		data () {

			let navigatorText;
			if (navigator && navigator.userAgent) {
				navigatorText = window.devType + '_' + navigator.userAgent.toUpperCase();
			}

			return {

				navigatorText,

				navBarInfo: {},
				locationText: undefined,
				recShopList: [], // 推荐门店
				nearShopList: [], // 附近门店
				topRatedShopList: [], // 受欢迎的门店
				maseLogo: this.$bk_getImageUrl('Def_Image_Logo_White.png'),

				showPage: undefined,
				locInfo: {
					// lat: 31.23522,
					// lng: 121.48054,
				}
			};
		},
		created () {

			localStorage.removeItem('ShopDetailId');
			localStorage.removeItem('ShopDetailCustId');

			let that = this;
			
			that.$bk_nativeGetAddress().then((res) => {
				this.locationText = res.address;
				this.locInfo = res.resLoc;

				that.refreshData();
			}).catch((error) => {
				this.locationText = error?.message || this.$bk_getTextWithLangCode('home_text_locErr');
				that.locInfo = {
					lat: 31,
					lng: 121,
				};
				that.refreshData();
			});


			// window.getCurrentPosition({
			// 	callback: function (e) {
			// 		// console.log('定位结果：', e);

			// 		if (e.success) {
			// 			that.locInfo = e.locInfo || {
			// 				lat: 31,
			// 				lng: 121,
			// 			};
			// 		} else {
			// 			that.locInfo = {
			// 				lat: 31,
			// 				lng: 121,
			// 			};
			// 		}

			// 		that.getLocAddress(that.locInfo);
			// 		that.refreshData();
			// 	}
			// });
		},
		activated () {
			if (this.locInfo?.lat) {
				this.refreshData();
			}
		},
		methods: {

			getLocAddress (locInfo) {
				
				if (locInfo.lat == 31) {
					this.locationText = this.$bk_getTextWithLangCode('home_text_locErr');
					return;
				}

				window.getAddressWithLocInfo({
          ...locInfo,
          callback: function (res) {

            bkLog.log('定位返回结果：', res);

            if (res.info == 'OK' && res.regeocode) {
              this.locationText = res.regeocode.formattedAddress;
            } else {
              this.locationText = this.$bk_getTextWithLangCode('home_text_locErr');
            }

          }.bind(this)
				});
			},

			refreshData () {
				this.requestGetRecommendedShopList();
				this.requestGetNearShopList();
				this.requestGetTopRatedShopList();
			},

			shopItemClick (item) {
				if (typeof window.showReserve == 'function') {
					window.showReserve({
						resShopInfo: item
					});
				}
			},

			showSubPage (type) {

				this.showPage = type;
			},

			async requestGetRecommendedShopList () {
				this.recShopList = await shopReq.requestGetRecommendedShopList(this, {}).catch(() => {}) || [];

				bkLog.log('推荐：', this.recShopList);
			},
			async requestGetNearShopList () {
				// ...this.locInfo,
				let parame = {
					lat: this.locInfo.lat,
					lng: this.locInfo.lng,
					pageNum: 1,
					pageSize: 12
				};

				let res = await shopReq.requestGetNearShopList(this, parame).catch(() => {}) || [];

				let nearShopList = [];

				res.map(function (obj, idx) {

					let index = Math.floor(idx / 4);

					let addItem = nearShopList[index];

					if (!addItem) {
						addItem = {list: []};
						nearShopList.push(addItem);
					}

					addItem.list.push(obj);
				});

				this.nearShopList = nearShopList;

				bkLog.log('附近：', this.nearShopList);
			},

			async requestGetTopRatedShopList () {

				let parame = {
					...this.locInfo,
					pageNum: 1,
					pageSize: 10
				};

				let res = await reportReq.requestGetTopRatedShopList(this, parame).catch(() => {});

				//
				this.topRatedShopList = res?.list || [];
			},
		}
	};
</script>

<style lang="less">

@import "./home";

</style>